<template>
    <!-- :class="{showBg:!isReload && address_list.length===0 -->
    <div class="shipping_address">
        <div class="title"><h3>收货地址(<i>{{address_list.length}}</i>)</h3><span>（最多可添加20个收货地址）</span></div>
        <div class="address_box">
            <button class="add_address" v-if="isReload==false">
                <i class="iconfont icon-jiahao" @click="create_address"></i>
                <i>添加新地址</i>
            </button>
            <div class="address" :class="{showbg:index==0}" v-for="(item,index) in address_list" :key="'A'+index">
                <p><span>{{item.receiver}}</span><span>{{item.phone}}</span></p>
                <p><span>{{item.province}}</span><span>{{item.city}}</span><span>{{item.area}}</span><span>{{item.address_detail}}</span>
                </p>
                <p><span @click="address_edit(item)">编辑</span><i><i v-if="index==0">[默认地址]</i><b v-else
                                                                                                 @click="setDefaultAddress(item.address_hash)">设为默认</b></i><span
                        @click="address_delete(item.address_hash)">删除</span></p>
            </div>
            <div
                    v-if="isReload"
                    style="width:100%;height:450px;"
                    v-loading="true"
                    element-loading-text="拼命加载中"
            ></div>
            <!--            <button class="add_address" v-if="isReload==false">-->
            <!--                <i class="iconfont icon-jiahao" @click="create_address"></i>-->
            <!--                <i>添加新地址</i>-->
            <!--            </button>-->
            <!-- 添加地址模态框 -->
            <el-dialog
                    title="新建收货地址"
                    :visible.sync="dialogVisible"
                    width="571px"
                    :before-close="handleClose">
                <ul class="modal_content">
                    <li>
                        <label><i>*</i>收 货 人：</label>
                        <el-input placeholder="请输入收货人姓名" v-model="formData.input.input1" clearable
                                  aria-required=""></el-input>
                        <b ref="input1"></b>
                    </li>
                    <li>
                        <label><i>*</i>手 机 号：</label>
                        <el-input placeholder="请输入手机号" v-model="formData.input.input2" clearable></el-input>
                        <b ref="input2"></b>
                    </li>
                    <li>
                        <label><i>*</i>收货地址：</label>
                        <!-- 省 -->
                        <el-select v-model="formData.select.select1" clearable placeholder="省/直辖市/自治区"
                                   class="area select" @change="select_province">
                            <el-option
                                    v-for="(item,index) in province"
                                    :key="'B'+index"
                                    :label="item.region_name"
                                    :value="item.region_id">
                            </el-option>
                        </el-select>
                        <!-- 市 -->
                        <el-select v-model="formData.select.select2" v-show="formData.select.select1" clearable
                                   placeholder="城市" class=" select" @change="select_city">
                            <el-option
                                    v-for="(item,index) in city"
                                    :key="'C'+index"
                                    :label="item.region_name"
                                    :value="item.region_id">
                            </el-option>
                        </el-select>
                        <!-- 区 -->
                        <el-select v-model="formData.select.select3" v-show="formData.select.select2" clearable
                                   placeholder="区/县" class=" select">
                            <el-option
                                    v-for="(item,index) in area"
                                    :key="'D'+index"
                                    :label="item.region_name"
                                    :value="item.region_id">
                            </el-option>
                        </el-select>
                        <b ref="select"></b>
                    </li>
                    <li>
                        <label><i>*</i>详细地址：</label>
                        <el-input placeholder="请输入详细地址" v-model="formData.input.input3" clearable></el-input>
                        <b ref="input3"></b>
                    </li>
                    <li>
                        <el-checkbox v-model="formData.checked">设为默认地址</el-checkbox>
                    </li>
                </ul>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="saveAddress">保存</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>

export default {
  name: 'shipping_address',
  data() {
    return {
      dialogVisible: false,
      //添加地址
      formData: {
        input: {
          input1: '',
          input2: '',
          input3: '',
        },
        checked: false,
        select: {
          select1: '',
          select2: '',
          select3: '',
        },
        address_hash: ''
      },
      // 省
      province: [],
      // 市
      city: [],
      // 区
      area: [],
      // 地址列表
      address_list: [],
      // 是否编辑
      isEdit: false,
      // 是否加载
      isReload: true

    }
  },
  watch: {
    'formData.select.select1': function () {
      this.formData.select.select2 = ''
      this.formData.select.select3 = ''
    },
    'formData.select.select2': function () {
      this.formData.select.select3 = ''
    }
  },
  methods: {
    handleClose(done) {
      this.isEdit = false
      this.clear_input()
      done()
    },
    // 设为默认地址
    setDefaultAddress(o) {
      this.$confirm('是否将该地址设为默认?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: 'set_default_address',
          data: {
            address_hash: o
          }
        }).then((res) => {
          if (res.code == 1) {
            this.$message({
              message: `${res.msg}`,
              type: 'success'
            });
            this.getPageAjax()
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {

      });
    },
    //编辑地址
    address_edit(o) {
      this.isEdit = true
      this.dialogVisible = true
      this.getAddressAjax(1, 1)

      this.formData.input.input1 = o.receiver
      this.formData.input.input2 = o.phone
      this.formData.input.input3 = o.address_detail
      this.formData.address_hash = o.address_hash
      this.formData.checked = Boolean(o.is_default)
    },
    //保存地址
    saveAddress() {
      let isTrue = this.form_validation()
      if (isTrue !== true) {
        return
      }
      let url = 'add_address'
      if (this.isEdit == true) {
        url = 'address_edit'
      }
      this.$http({
        url: url,
        data: {
          address_hash: this.formData.address_hash,
          receiver: this.formData.input.input1,
          phone: this.formData.input.input2,
          province: this.formData.select.select1,
          city: this.formData.select.select2,
          area: this.formData.select.select3,
          address: this.formData.input.input3,
          is_default: Number(this.formData.checked)
        },
      }).then(res => {
        if (res.code == 1) {
          this.$message({
            message: `${res.msg}`,
            type: 'success'
          });
          this.getPageAjax()
        }
      }).catch(err => {
        console.log(err);
      });
      this.isEdit = false
      this.dialogVisible = false
    },
    //删除地址
    address_delete(o) {
      this.$confirm('是否删除该地址?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: 'address_delete',
          data: {
            address_hash: o
          }
        }).then((res) => {
          if (res.code == 1) {
            this.$message({
              message: `${res.msg}`,
              type: 'success'
            });
            this.getPageAjax()
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {

      });
    },
    // 表单验证
    form_validation() {
      if (!this.formData.input.input1) {
        this.$refs.input1.innerHTML = "请填写收货人姓名"
        return false
      }
      if (!this.formData.input.input2) {
        this.$refs.input2.innerHTML = "请填写手机号，并且仔细确认"
        return false
      }
      if (!this.formData.select.select1 || !this.formData.select.select2 || !this.formData.select.select3) {
        this.$refs.select.innerHTML = "请填写省/市/区"
        return false
      }
      if (!this.formData.input.input3) {
        this.$refs.input3.innerHTML = "请填写详细收货地址"
        return false
      }
      return true
    },
    // 清空input数据
    clear_input() {
      this.formData.address_hash = '',
        this.formData.input.input1 = '',
        this.formData.input.input2 = '',
        this.formData.input.input3 = '',
        this.formData.select.select1 = '',
        this.formData.select.select2 = '',
        this.formData.select.select3 = '',
        this.formData.checked = false,
        this.address_hash = '',
        this.$refs.input1.innerHTML = '',
        this.$refs.input2.innerHTML = '',
        this.$refs.select.innerHTML = '',
        this.$refs.input3.innerHTML = ''
    },
    // 省数据
    create_address() {
      // if (this.address_list.length < 20) {
        this.dialogVisible = true
        this.getAddressAjax(1, 1)
      // } else {
      //   this.$message({
      //     message: `最多可添加20个收获地址`,
      //     type: 'warning'
      //   });
      // }
    },
    // 市数据
    select_province(o) {
      this.getAddressAjax(2, o)
    },
    // 区数据
    select_city(o) {
      this.getAddressAjax(3, o)
    },
    // 获取省/市/区数据的ajax
    getAddressAjax(d, o) {
      this.$http({
        url: 'get_addressData',
        data: {
          type: d,
          parent_id: o
        }
      }).then((res) => {
        if (res.code == 1) {
          if (d == 1) {
            this.province = res.data.region
          }
          if (d == 2) {
            this.city = res.data.region
          }
          if (d == 3) {
            this.area = res.data.region
          }
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取页面数据的ajax
    getPageAjax() {
      this.$http({
        url: 'address_list',
        data: {}
      }).then((res) => {
        this.isReload = false
        if (res.code == 1) {
          this.address_list = res.data.address
        }
      }).catch((err) => {
        console.log(err)
      })
    },
  },
  created() {
    this.getPageAjax()
  }
}
</script>
<style lang="scss" scoped>
    .shipping_address {
        height: 100%;
        padding: 20px 20px 58px;

        .title {
            display: flex;
            align-items: flex-end;
            justify-content: center;
            padding: 15px 0;

            h3 {
                font-size: 20px;
            }

            span {
                color: #999;
                font-size: 14px;
            }
        }
    }

    .showBg {
        background: url('../../assets/img/null.png') no-repeat 50% 50%;
        background-size: 50%;
    }

    .address_box {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .address {
            box-sizing: border-box;
            width: 270px;
            height: 155px;
            margin: 21px;
            padding: 15px 20px;
            font-size: 12px;
            border: 2px solid #DDDDDD;
            cursor: pointer;

            > p:first-child {
                display: flex;
                justify-content: space-between;
                margin-bottom: 5px;
            }

            > p:nth-child(2) {
                height: 90px;
                overflow: hidden;

                > span {
                    margin-right: 6px;
                    line-height: 18px;
                }
            }

            > p:last-child {
                display: flex;
                justify-content: space-between;

                > i {
                    > i {
                        color: #45A3DC;
                    }

                    > b:hover {
                        color: #45A3DC;
                    }
                }

                > span:first-child:hover {
                    color: #45A3DC;
                }

                > span:last-child:hover {
                    color: red;
                }
            }
        }

        .showbg {
            background: url('../../assets/img/border_image.png') no-repeat;
            border: none;
        }

        .add_address {
            border: none;
            outline: none;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 270px;
            height: 155px;
            margin: 21px;
            border: 2px solid #DDDDDD;
            background: transparent;

            i:first-child {
                width: 35px;
                height: 35px;
                text-align: center;
                line-height: 35px;
                font-size: 28px;
                color: #888;
                border-radius: 50%;
                margin-bottom: 10px;
                cursor: pointer;
            }
        }
    }

    // 模态框
    .modal_content {
        > li {
            display: flex;
            align-items: center;
            padding: 15px 0;
            position: relative;

            > label {
                display: flex;
                align-items: center;
                min-width: 86px;

                > i {
                    padding-top: 10px;
                    font-size: 22px;
                    color: #f51200;
                    margin-right: 5px;
                }
            }

            > b {
                font-size: 12px;
                position: absolute;
                left: 100px;
                top: 60px;
                color: #f51200;
            }
        }

        > li:last-child {
            padding: 15px 0 0 85px;
        }
    }
</style>
<style scoped>
    .modal_content > li:nth-child(3) >>> .el-input {
        width: 130px;
    }

    .modal_content > li:nth-child(3) > .area >>> .el-input {
        width: 160px;
    }

    .modal_content > li:nth-child(3) > .select:nth-child(3) {
        margin: 0 12px;
    }

    .address_box >>> .el-dialog__header {
        text-align: center;
    }

    .address_box >>> .el-dialog__footer {
        text-align: center;
    }

    .address_box >>> .el-button {
        border-radius: 20px;
        padding: 12px 40px;
    }

    .address_box >>> .el-dialog__title {
        font-size: 24px;
    }

    .address_box >>> .el-icon-close:before {
        font-size: 26px;
    }
</style>
